var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 340.533 340.533"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.768 290.197c-6.137 0-12.25-5.831-13.412-7.002-4.194-3.092-115.082-86.691-127.269-98.856-4.422-4.444-5.203-8.894-5.074-11.856.288-7.089 5.768-11.935 6.389-12.463L129.738 57.946c1.351-1.474 7.617-7.611 13.577-7.611 2.717 0 9.031 1.243 9.031 12.691v52.623H326.47a11.595 11.595 0 011.903-.156c2.03 0 12.16.774 12.16 15.976v80.87c0 11.187-7.927 14.153-12.118 14.153H156.012v48.23c0 13.469-6.419 15.475-10.244 15.475zm0-9.746v4.87-4.87z",
    fill: "#88919d"
  })));
}

export default SvgBackArrow;